module.exports = __webpack_public_path__ + "img/样例1.0c31a270.png";